<script lang="ts">
  import { parseDynamicData } from '$shared/helpers/utils';
  import type { ObjectType } from 'src/global';
  interface Props {
    value?: ObjectType<string>;
  }

  let { value = {} }: Props = $props();
</script>

<div class="comp-object-list-alert-type">
  {#each Object.entries(value) as [key, value]}
    <div class="table-inner-i">
      <div data-cy={`${key}-k`} class="key">{key}</div>
      <div data-cy={`${key}-v`} class="value">{parseDynamicData(value)}</div>
    </div>
  {/each}
</div>

<style>
  .table-inner-i {
    display: flex;
    align-items: flex-start;
    padding: 12px 16px;
    line-height: 20px;
  }
  .table-inner-i .key {
    width: 150px;
    margin-right: 16px;
    flex-shrink: 0;
    font-weight: 500;
    color: var(--black);
  }
  .table-inner-i .value {
    text-align: left;
    word-break: break-word;
  }
</style>
